import { render, staticRenderFns } from "./ServiceProcessDetail.vue?vue&type=template&id=4ad6e704&scoped=true&"
import script from "./ServiceProcessDetail.vue?vue&type=script&lang=ts&"
export * from "./ServiceProcessDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProcessDetail.vue?vue&type=style&index=0&id=4ad6e704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad6e704",
  null
  
)

export default component.exports